// extracted by mini-css-extract-plugin
export default {"emptyContent":"styles_emptyContent__ew+YC","textWrapper":"styles_textWrapper__GfLZ8","title":"styles_title__2jdz9","subtitle":"styles_subtitle__yGcBA","image":"styles_image__O9fzz"};